import React from 'react';
import './Machinesthin.css';
import machth from '../../../imgs/machthin.webp';


const Machinesthin = () => {
    return (
        <div className="Advantagpall-container">
            <div className='Ordinarys'>
                <h2 className="Advantagpall-title">Disha High-Speed Injection Molding
                    Machines for Thin-wall Products have three advantages</h2>
                <div className="Advantagpall-content">
                    <ul className="Advantagpall-text">
                        <li>Innovative design of plasticizing system achieves
                            low-temperature injection; it makes the machine energy-saving, and environmental,
                            and manufactures products with high tenacity and toughness.</li>
                        <li>Advanced hydraulic system achieves low-pressure injection; it makes
                            the machine gain better mechanical protection, has a longer mold service life,
                            and manufactures products with low stress and deformation.</li>
                        <li>Optimized control system achieves fast response speed; it makes the machine obtain a higher
                            shot rate in a short time and reaches the best within 0.3 seconds.</li>
                    </ul>
                    <div className="advantpl">
                        <img src={machth} alt="72 Cavity PET Preforms Machine" className="advantpla-image" />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Machinesthin;
